import { useAuthStore } from '@/stores/auth.store'
import axios from 'axios'

const instance = axios.create({
  timeout: 40000,
  headers: {
    'Content-Type': 'application/json'
  }
})

/**
 * @description This function is used to send alert to slack
 * @param error error object
 */
const alert = (error: any) => {
  // get current domain
  const domain = window.location.hostname
  if (domain !== 'www.jdoodle.com') return
  const path = `${domain}${window.location.pathname}`

  let url: string | null = null
  const endpoint: string = error?.config?.url || ''
  let status: number | string = (error?.response?.status as number) || 0
  const userEmail: string = useAuthStore().userEmail || 'Not logged in'

  let request = {}

  if (status && status >= 500) {
    url = '/triggers500'
    request = {
      path,
      endpoint,
      status,
      userEmail
    }
  } else if (status && status >= 400) {
    url = '/triggers400'
    request = {
      path,
      endpoint,
      status,
      userEmail
    }
  } else return

  status = status.toString()
  instance.post(url, request)
}

export default { alert }
